import {LOCAL_STORE_ACCOUNT, LOCAL_STORE_SEASON} from '@/local-store.keys';

export default ({
  namespaced: true,
  state: () => ({
    isAuthenticated: false,
    authChecked: false,
    isLogout: false,
  }),
  mutations: {
    setAuthenticated(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
    setAuthChecked(state, authChecked) {
      state.authChecked = authChecked;
    },
    login(state) {
      window.localStorage.removeItem(LOCAL_STORE_ACCOUNT);
      window.localStorage.removeItem(LOCAL_STORE_SEASON);
      state.isAuthenticated = false;
      state.isLogout = false;
    },
    beginLogout(state) {
      window.localStorage.removeItem(LOCAL_STORE_ACCOUNT);
      window.localStorage.removeItem(LOCAL_STORE_SEASON);
      state.isAuthenticated = false;
      state.isLogout = true;
    },
    finishLogout(state) {
      state.isLogout = false;
      state.isAuthenticated = false;
    },
  },
  actions: {
    async completeSession({commit, dispatch}) {
      const success = await dispatch('user/loadAuthInfo', null, {root: true});
      if (success) {
        commit('setAuthenticated', true);
      }
      return success;
    },
    async bootstrap({commit, dispatch}) {
      await dispatch('completeSession');
      commit('setAuthChecked', true);
    },
    logout({commit, state}) {
      if (state.isLogout) {
        return;
      }
      commit('beginLogout');
    },
    finishLogout({commit}) {
      commit('finishLogout');
    },
  },
})
